"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frontEndUrlEnv = exports.awsUrlEnv = exports.ddEnv = exports.ddService = void 0;
exports.ddService = process.env.DD_SERVICE;
exports.ddEnv = process.env.DD_ENV;
exports.awsUrlEnv = process.env.AWS_S3_URL;
exports.frontEndUrlEnv = process.env.FRONT_END_URL;
